import 'magnific-popup'
import './frontend/lightbox'
import './frontend/responsive-slides'
import './frontend/gallery'

window.$ = window.jQuery = jQuery
